// extracted by css-extract-rspack-plugin
export default {"row":"L7N9h"};